<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>新手引导配置</span>
          <!--          <el-button v-permisaction="['config:newUserGuide:uploadCdn']" :loading="loading" size="mini" style="margin-left: 10px" type="primary" @click="uploadCdn()">同步到S3</el-button>-->
          <syncVersion :in-method="uploadCdn" :params="params" />

          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="step" label="步数">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.step" />
            </template>
          </el-table-column>
          <el-table-column prop="guideType" label="类型">
            <template slot-scope="scope">
              <el-select v-model="scope.row.guideType" placeholder="请选择">
                <el-option
                  v-for="item in selectType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>

              <el-button v-if="scope.row.guideType === 2" style="margin-left: 10px" type="text" @click="dialogVisible[scope.$index].visible = true">配置</el-button>
              <el-dialog
                title="提示"
                :visible.sync="dialogVisible[scope.$index].visible"
                width="500px"
                :before-close="d=>handleClose(d, scope.$index)"
              >
                <el-form :inline="true">
                  <el-form-item label="事件类型">
                    <el-select v-model.number="scope.row.eventType" style="width: 120px;" placeholder="请选择">
                      <el-option
                        v-for="(item, index) in eventType"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="点数">
                    <el-input v-model.number="scope.row.value" placeholder="点数" />
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible[scope.$index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogVisible[scope.$index].visible = false">确 定</el-button>
                </span>
              </el-dialog>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="点数">
            <template slot-scope="scope">
              <span v-if="scope.row.guideType === 2">
                类型:{{ getEventText(scope.row.eventType) }}, 点数:{{ scope.row.value }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="奖励">
            <template slot-scope="scope">
              <span v-if="scope.row.guideType === 2">
                {{ getRewardList(scope.row.prize) }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="配置" width="120px">
            <template slot-scope="scope">
              <el-button v-if="scope.row.guideType === 2" type="text" @click="drawer[scope.$index].visible = true">配置</el-button>
              <el-drawer
                title="配置"
                :visible.sync="drawer[scope.$index].visible"
                :with-header="false"
                size="650px"
              >
                <el-form :inline="true">
                  <el-row v-for="(item, index) in scope.row.prize" :key="index">
                    <el-form-item label="道具类型">
                      <el-select v-model.number="item.propsId" style="width: 120px;" placeholder="请选择">
                        <el-option
                          v-for="(item, index) in propType"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="数量">
                      <el-input v-model.number="item.num" style="width: 150px;" placeholder="数量" />
                    </el-form-item>
                    <el-form-item>
                      <el-button v-permisaction="['config:rewardCollectEdit:del']" type="danger" @click="delElement(scope.$index, index)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-button v-permisaction="['config:rewardCollectEdit:add']" style="margin-top: 5px" type="primary" @click="addElement(scope.$index)">+</el-button>
                </el-form>
              </el-drawer>
              <el-button v-if="scope.row.guideType === 3" type="text" @click="drawer2[scope.$index].visible = true">配置</el-button>
              <el-drawer
                title="配置"
                :visible.sync="drawer2[scope.$index].visible"
                :with-header="false"
                size="650px"
              >
                <el-form :inline="true">
                  <el-row v-for="(item, index) in scope.row.chessBoard" :key="index">
                    <el-form-item label="名称">
                      <el-input v-model="item.name" style="width: 150px;" placeholder="名称" />
                    </el-form-item>
                    <el-form-item label="皮肤ID">
                      <el-input v-model.number="item.iconId" style="width: 150px;" placeholder="皮肤ID" />
                    </el-form-item>
                    <el-form-item>
                      <el-button v-permisaction="['config:rewardCollectEdit:del']" type="danger" @click="delElement(scope.$index, index)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-button v-permisaction="['config:rewardCollectEdit:add']" style="margin-top: 5px" type="primary" @click="addElement(scope.$index)">+</el-button>
                </el-form>
              </el-drawer>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <el-button v-permisaction="['config:newUserGuide:del']" type="danger" @click="del(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: center">
          <el-button v-permisaction="['config:newUserGuide:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:newUserGuide:add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg, uploadCdn } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'NewUserGuide',
  components: { SyncData, SyncVersion, ClearCacheApply },
  data() {
    return {
      key: 'NoviceGuide',
      params: { name: 'newUserGuide', type: 'NoviceGuide' },
      dialogVisible: [{ visible: false }],
      drawer2: [{ visible: false }],
      loading: false,
      name: 'newUserGuide',
      drawer: [{ visible: false }],
      selectType: [
        { label: '建造', value: 1 },
        { label: '投骰子', value: 2 },
        { label: '选择棋子', value: 3 }
      ],
      propType: [
        { label: '金币', value: 14 },
        { label: '盾', value: 16 }
      ],
      eventType: [
        { label: '金币', value: 5 },
        { label: '打', value: 1 },
        { label: '偷', value: 2 }
      ],
      formData: [{
        step: 0,
        guideType: 1,
        value: 0,
        eventType: 5,
        prize: [],
        chessBoard: []
      }]
    }
  },
  created() {
    // this.getChessBoardType()
    this.getTables()
  },
  methods: {
    uploadCdn,
    handleClose(done, index) {
      this.dialogVisible[index].visible = false
    },
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.step <= 0) {
          this.msgError('步骤不能小于等于0')
          return
        }

        if (_data.guideType === 2) {
          if (_data.value <= 0) {
            this.msgError('点数不能小于等于0')
            return
          }
        }

        if (_data.guideType === 3) {
          for (const i in _data.chessBoard) {
            const val = _data.chessBoard[i]
            if (val.name === '') {
              this.msgError('皮肤名称不能为空')
              return
            }

            if (val.iconId <= 0) {
              this.msgError('皮肤ID不能小于多余0')
              return
            }
          }
        }
      }
      const data = JSON.stringify(this.formData)
      console.log('data', data)
      updateCommonCfg({ name: 'newUserGuide', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.loading = true
      getCommonCfg({ name: 'newUserGuide' }).then(res => {
        this.loading = false
        if (res.code === 200) {
          res.data.forEach(item => {
            this.drawer.push({ visible: false })
            this.drawer2.push({ visible: false })
            this.dialogVisible.push({ visible: false })
          })
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        step: 0,
        guideType: 1,
        value: 0,
        eventType: 5,
        prize: [],
        chessBoard: []
      })
      this.drawer.push({ visible: false })
      this.drawer2.push({ visible: false })
      this.dialogVisible.push({ visible: false })
    },
    addKingInfo(index) {
      this.formData[index].kingInfos.push({
        'uid': 0,
        'money': 1,
        's_picture': ''
      }
      )
    },
    addElement(index) {
      if (this.formData[index].guideType === 2) {
        this.formData[index].prize.push({
          'propsId': 14,
          'num': 1
        })
      } else {
        this.formData[index].chessBoard.push({
          'iconId': 0,
          'name': ''
        }
        )
      }
    },
    delElement(index, i) {
      if (this.formData[index].guideType === 2) {
        this.formData[index].prize = this.formData[index].prize.filter((item, key) => {
          return i !== key
        })
        let count = 0
        this.formData[index].element.forEach((item, index) => {
          count++
          this.formData[index].element[index].id = count
        })
      } else {
        this.formData[index].chessBoard = this.formData[index].chessBoard.filter((item, key) => {
          return i !== key
        })
      }
    },
    delKingInfo(index, i) {
      this.formData[index].kingInfos = this.formData[index].kingInfos.filter((item, key) => {
        return i !== key
      })
    },
    del(index) {
      this.formData = this.formData.filter((item, key) => {
        return index !== key
      })
    },
    // uploadCdn() {
    //   this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再看看',
    //     type: 'warning'
    //   }).then(() => {
    //     uploadCdn({ name: this.name, type: this.key }).then(res => {
    //       if (res.code === 200) {
    //         this.msgSuccess(res.msg)
    //         this.getTables(name)
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    // },
    getEventText(t) {
      var text = ''
      for (const i in this.eventType) {
        const val = this.eventType[i]
        if (val.value === t) {
          text = val.label
          break
        }
      }

      return text
    },
    getRewardList(prize) {
      const str = []
      for (const i in prize) {
        const r = prize[i]
        for (const k in this.propType) {
          const rt = this.propType[k]
          if (r.propsId === rt.value) {
            str.push(rt.label + '*' + r.num)
            break
          }
        }
      }
      return str.join(',')
      // return getRewardListForPropsId(prize, this.rewardType)
    }
  }
}
</script>

<style scoped>
</style>
